import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { TaskFooter } from "../utils/TaskDetails";

function Task({ task, index, handleEditTask, Priority, Task_Code, Assignee, Due_Date }) {
 
  // const [isEditing, setIsEditing] = useState(false);
  // const [columnTitle, setColumnTitle] = useState(task?.Title);

  // const [TaskEditQuery] = useMutation(TASK_NAME_EDIT, {
  //   onCompleted: () => {
  //     SuccessToast("Task Name Edited Sucessfuly!");
  //   },
  //   onError: (err) => {
  //     ErrorToast(`${err.message}`);
  //   },
  // });

  // const toggleEdit = () => setIsEditing(!isEditing);
  // const handleChangeTitle = (e) => {
  //   setColumnTitle(e.target.value);
  // };
  // const handleCancelEdit = () => {
  //   setIsEditing(false);
  //   setColumnTitle(task?.Title);
  // };
  // const handleFocus = (event) => {
  //   const value = event.target.value;
  //   event.target.value = "";
  //   event.target.value = value;
  // };
  // const handleSaveEdit = async () => {
  //   await TaskEditQuery({
  //     variables: {
  //       id: task._id,
  //       userInput: {
  //         Title: columnTitle,
  //       },
  //     },
  //   });
  //   setIsEditing(false);
  // };
  // handleRenameColumn(column?._id, columnTitle);

  // Implement the save logic
  // if (isEditing) {
  //   return (
  //     <>
  //       <OutsideClick setToggled={setIsEditing}>
  //         {/* <EidtContainer>
  //           <HeaderInputBox>
  //             <TitleEditInput value={columnTitle} onChange={handleChangeTitle} autoFocus onFocus={handleFocus} />
  //             <EditButtons>
  //               <IconButton onClick={handleSaveEdit}>
  //                 <FaCheck size={14} />
  //               </IconButton>
  //               <IconButton onClick={handleCancelEdit}>
  //                 <FaTimes size={14} />
  //               </IconButton>
  //             </EditButtons>
  //           </HeaderInputBox>
  //         </EidtContainer> */}
  //         <EditTask open={isEditing} TaskId={task._id} />
  //       </OutsideClick>
  //     </>
  //   );
  // }
  return (
    <>
      <Draggable draggableId={task._id} index={index}>
        {(provided, snapshot) => (
          <StyledTask
            onDoubleClick={() => handleEditTask(task._id)} // Update here
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
          >
            {task?.Title}
            <TaskFooter Priority={Priority} Assignee={Assignee} Task_Code={Task_Code} Due_Date={Due_Date} />
          </StyledTask>
        )}
      </Draggable>
      {/* {
      isEditing &&
      <EditTask open={isEditing} TaskId={task._id} />
    } */}
    </>
  );
}

export default Task;

const StyledTask = styled.div`
  user-select: none;
  padding: 8px 16px;
  margin: 0 0 8px 0;
  min-height: 50px;
  /* width: 250px; */
  /* overflow-y: visible; */
  font-size:0.9rem;
  background-color: ${(props) => (props.isDragging ? "lightgreen" : "white")};
  border: 1px solid transparent; // Default border color
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); // Subtle shadow for non-dragging state
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border-radius: 5px;
  rotate: ${(props) => (props.isDragging ? "5deg" : "0deg")};
  &:hover {
    border: 1px solid #9ecd97; // Blue border on hover
    /* transform: scale(1.01); */
    /* background-color: #f0f0f0; */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); // More pronounced shadow on hover
  }

  // Ensuring text wraps
  white-space: normal; // Allow text to wrap
  word-wrap: break-word; // Break the word to prevent overflow
  overflow: hidden; // Hide the overflowed content
`;
